import { classNames } from "../lib/format";

type Props = {
  title?: string;
  description?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
};

export function SectionCard({ title, description, actions, children, className }: Props) {
  return (
    <section className={classNames("ks-card", className)}>
      {(title || description || actions) && (
        <header className="flex items-start justify-between gap-3 border-b border-ink-200 px-4 py-3">
          <div>
            {title && <h2 className="text-sm font-semibold text-ink-900">{title}</h2>}
            {description && (
              <p className="mt-0.5 max-w-prose text-xs text-ink-600">{description}</p>
            )}
          </div>
          {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
        </header>
      )}
      <div className="p-4">{children}</div>
    </section>
  );
}
